// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2646) return "static/chunks/2646.ee4c7e46959cb68e.js";
	if (chunkId === 8739) return "static/chunks/8739.b887518ddfcde39b.js";
	if (chunkId === 3312) return "static/chunks/3312.7f0d0792b6c4da0b.js";
	if (chunkId === 3079) return "static/chunks/3079.5980d1c62429a2a5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"445":"fd95cac3","1466":"5a8d12aa"}[chunkId] || chunkId) + "-" + {"445":"72f6b2e024d54708","447":"e0d727e63b228595","1466":"d645cf1ed02217d2","6175":"6cfdf6d479ba88fa","7766":"9fcb4aceabb803d6","8030":"7ba82bb045c4c697"}[chunkId] + ".js";
};